import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import orderBy from 'lodash/orderBy';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import remove from 'lodash/remove';
import { CheckboxList, Input, MultiRadio, Textarea } from 'shared/components';

import './DigitalAssessmentQuestion.scss';

const MAX_LENGTH = 1000;

const transformRadio = (listOfOptions) =>
  listOfOptions.map((option) => {
    const newObj = {
      label: option.value,
      key: option.id,
      value: option.id.toString(),
    };
    return newObj;
  });

const transformCheckbox = (listOfOptions, selectedValues) =>
  listOfOptions.map((option) => {
    const newObj = {
      label: option.value,
      key: option.id,
      value: option.id.toString(),
      checked: selectedValues && selectedValues.indexOf(option.id.toString()) !== -1 ? true : false,
    };
    return newObj;
  });

class DigitalAssessmentQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedValue:
        props.selectedValue && !isEmpty(props.selectedValues) ? props.selectedValue : '',
      selectedValues:
        props.selectedValues && !isEmpty(props.selectedValues) ? props.selectedValues : [],
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedValues !== this.props.selectedValues ||
      prevProps.selectedValue !== this.props.selectedValue
    ) {
      const { selectedValues, selectedValue } = this.props;

      this.setState({
        selectedValues: selectedValues && !isEmpty(selectedValues) ? selectedValues : [],
        selectedValue: selectedValue && !isEmpty(selectedValues) ? selectedValue : '',
      });
    }
  }

  onChange(e) {
    const { id, changeAnswer, type } = this.props;
    const { value } = e.target;

    if (type === 'numeric' && value.length > 6) {
      return;
    }
    changeAnswer(id, value);

    this.setState({
      selectedValue: value,
    });
  }

  onChangeCheckbox(e) {
    const { selectedValues } = this.state;
    const { id, changeAnswer } = this.props;
    const value = e.target.name;

    if (e.target.checked) {
      selectedValues.push(value);
    } else {
      let key = selectedValues.indexOf(value);
      delete selectedValues[key];
      remove(selectedValues, (n) => n === value);
    }

    changeAnswer(id, selectedValues);
    this.setState({
      selectedValues: selectedValues,
    });
  }

  render() {
    const {
      cycleFieldValues,
      label,
      type,
      parentCycleFieldId,
      lastChild,
      displayQuestion,
      error,
      requiredFlag,
      id,
    } = this.props;

    const { selectedValue, selectedValues } = this.state;

    let showChildFieldValue = find(cycleFieldValues, { showChildFields: true });
    const showChildClassName =
      !isEmpty(showChildFieldValue) && showChildFieldValue.id == selectedValue ? ' show-child' : '';
    const lastChildClassName = lastChild ? ' last-child' : '';
    const constisChildClassName = parentCycleFieldId ? ' is-child' : '';
    const displayClassName = displayQuestion ? '' : ' d-none';
    const errorMessage = error ? this.props.t('errors.fieldMandatory') : '';

    return (
      <div
        id={id}
        className={`border-gray${showChildClassName}${lastChildClassName}${constisChildClassName}${displayClassName}`}>
        {type === 'select_one' && (
          <MultiRadio
            radioList={transformRadio(orderBy(cycleFieldValues, ['displayOrder'], ['asc']))}
            checkedValue={selectedValue}
            onChange={this.onChange}
            title={label}
            description={requiredFlag ? '' : this.props.t('common.labels.optional')}
            errors={errorMessage}
          />
        )}

        {type === 'select_multiple' && (
          <CheckboxList
            onChange={this.onChangeCheckbox}
            checkboxes={transformCheckbox(
              orderBy(cycleFieldValues, ['displayOrder'], ['asc']),
              selectedValues
            )}
            title={label}
          />
        )}

        {type === 'numeric' && (
          <div className="numeric-section">
            <h6 className="title">{label}</h6>
            <Input
              type="number"
              name={`numericField-${id}`}
              value={selectedValue}
              min={0}
              infoText={requiredFlag ? '' : this.props.t('common.labels.optional')}
              onChange={this.onChange}
              errors={errorMessage}
              required
            />
          </div>
        )}

        {type === 'freeform_text' && (
          <div className="freeform-text">
            <h6 className="title">{label}</h6>
            <Textarea
              className="mb-1"
              name="sameMessage"
              value={selectedValue}
              onChange={this.onChange}
              maxLength={MAX_LENGTH}
              error={errorMessage}
              optionalText={requiredFlag ? '' : 'common.labels.optional'}
            />
          </div>
        )}
      </div>
    );
  }
}

export default withTranslation()(DigitalAssessmentQuestion);
DigitalAssessmentQuestion.propTypes = {
  changeAnswer: PropTypes.func,
  cycleFieldValues: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      value: PropTypes.string,
      displayOrder: PropTypes.number,
      showChildFields: PropTypes.bool,
    })
  ),
  label: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  selectedValue: PropTypes.string,
  selectedValues: PropTypes.arrayOf(PropTypes.string),
  parentCycleFieldId: PropTypes.number,
  lastChild: PropTypes.bool,
  displayQuestion: PropTypes.bool,
  error: PropTypes.bool,
  requiredFlag: PropTypes.bool,
  id: PropTypes.number,
  t: PropTypes.func.isRequired,
};
